import * as React from "react";

export class HeadCell extends React.Component<{
    colSpan?: number;
    additionalClassNames?: string;
}, {}> {
    baseClass: string;

    constructor(props) {
        super(props);
        this.baseClass = "rj-racing-table__head";
    }

    render() {
        const cls = this.baseClass +
            (this.props.additionalClassNames ? ` ${this.props.additionalClassNames}` : "");
        return (
            <th colSpan={this.props.colSpan} className={cls}>
                {this.props.children}
            </th>
        );
    }
}